import { render, staticRenderFns } from "./FeedbackMediaUploader.vue?vue&type=template&id=ab113a38&scoped=true"
import script from "./FeedbackMediaUploader.vue?vue&type=script&lang=js"
export * from "./FeedbackMediaUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab113a38",
  null
  
)

export default component.exports